import logo from '../assets/logo.png'
import bread01 from '../assets/bread01.png'
import bread02 from '../assets/bread02.png'
import bread03 from '../assets/bread03.png'
import bread04 from '../assets/bread04.png'
import bread05 from '../assets/bread05.png'
import bread06 from '../assets/bread06.png'
import story01 from '../assets/story01.png'
import story02 from '../assets/stroy02.png'
import menuBread01 from '../assets/menu_bread_01.png'
import menuBread02 from '../assets/menu_bread_02.png'
import gallery01 from '../assets/gallery01.png'
import gallery02 from '../assets/gallery02.png'
import gallery03 from '../assets/gallery03.png'
import gallery04 from '../assets/gallery04.png'
import newsLetter from '../assets/newsletter.png'
import menuSweets01 from '../assets/menu_sweets_01.png'
import menuSweets02 from '../assets/menu_sweets_02.png'
import menuDrinks01 from '../assets/menu_drinks_01.png'
import menuDrinks02 from '../assets/menu_drinks_02.png'

export default {
  logo,
  bread01,
  bread02,
  bread03,
  bread04,
  bread05,
  bread06,
  story01,
  story02,
  menuBread01,
  menuBread02,
  gallery01,
  gallery02,
  gallery03,
  gallery04,
  newsLetter,
  menuSweets01,
  menuSweets02,
  menuDrinks01,
  menuDrinks02,
}
